var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<design-layer-editor layer=\"sl\" designer=\"$ctrl.designer\"><div ng-include=\"'design-layer.color.html'\"></div></design-layer-editor>";
var id1="design-layer-editor.color.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;